import '@refinitiv-ui/elements/button';
import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import '../components/heimdall-error.js';
import '../components/heimdall-loader.js';
import '../components/login-frame.js';
import '../theme.js';
import { createFinalizeRedirection$ } from '@lseg-ciam/auth/login';
import {
  knownLinkOrigins,
  workspaceFinalizeLoginHook,
} from '../workspace-config.js';

@customElement('heimdall-redirect')
export class HeimdallRedirect extends LitElement {
  @state()
  _error: unknown = null;

  firstUpdated() {
    createFinalizeRedirection$({
      knownLinkOrigins,
      onFinalizeLogin: workspaceFinalizeLoginHook,
    }).subscribe({
      error: (error) => {
        this._error = error;
      },
    });
  }

  render() {
    return html`<login-frame> ${this.getFrameContent()} </login-frame>`;
  }

  getFrameContent() {
    if (this._error) {
      return html`<heimdall-error .error=${this._error}></heimdall-error>`;
    }
    return html`<heimdall-loader />`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'heimdall-redirect': HeimdallRedirect;
  }
}
